import React from "react";

import LoginContainer from "@commr/admin/components/login/loginContainer";

const LoginPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <LoginContainer />
);

export default LoginPage;
